<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentBlog">
        <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
              <h4>{{ currentBlog.title }}</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div v-if="activeUserInfo.uid == currentBlog.user_id" class="email__actions--single flex items-baseline">
              <feather-icon icon="UploadIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="saveBlog()"></feather-icon>
              <feather-icon icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="deleteBlog()"></feather-icon>
              <!-- <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />
              <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextMail')" /> -->
            </div>
          </div>
        </div>
        <component :is="scrollbarTag" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card class="px-4" >
                <!-- MAIL HEAD -->
                <div class="vx-row">
                  <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                    <!-- Sender Details -->
                    <div class="flex items-center">
                      <div class="flex flex-col">
                        <h5 class="mb-1">{{ currentBlog.name }}</h5>
                      </div>
                    </div>
                    <!-- /Sender Details -->
                    <!-- Mail Time & Date -->
                    <div class="flex flex-col justify-end">
                      <span class="text-right">{{ currentBlog.update_time | time }}</span>
                      <div class="flex justify-end mt-2">
                        <span class="text-right">{{ currentBlog.update_time | date(true) }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- /Mail Time & Date -->
                </div>
                <!-- MAIL CONTENT -->
                <div v-if="activeUserInfo.uid == currentBlog.user_id">
                  <br>

                  <div class="vx-row">
                    <div class="output ql-snow w-full" >
                      <!-- <div class="ql-editor  w-full"> -->
                      <quill-editor v-model="content" :options="editorOption">
                        <div id="toolbar" slot="toolbar">
                          <button class="ql-bold">Bold</button>
                          <button class="ql-italic">Italic</button>
                          <select class="ql-size">
                            <option value="small"></option>
                            <option selected></option>
                            <option value="large"></option>
                            <option value="huge"></option>
                          </select>
                          <select class="ql-font">
                            <option selected="selected"></option>
                            <option value="serif"></option>
                            <option value="monospace"></option>
                          </select>
                          <!-- <button class="ql-image"></button> -->
                          <!-- <button class="ql-video"></button> -->
                          </div>
                        </quill-editor>
                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div>
                  <div class="vx-row">
                    <div class="output ql-snow" v-if="activeUserInfo.uid != currentBlog.user_id">
                      <div class="ql-editor" v-html="currentBlog.detail"></div>
                    </div>
                  </div>
                </div>
                <!-- <div v-if="currentAlarm.link" >
                  <feather-icon icon="play" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="goPage()"></feather-icon>
                </div> -->
              </vx-card>
            </div>
          </div>

        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showThread            : false,
      activePrompt          : false,
      message               : '',
      title                 : '',
      deleteFileName        : [],
      newFileList           : [],
      fileList              : [],
      uploadPrompt          : false,
      fileMaxSize           : 15360000,
      content               : '',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
      placeholder: '내용을 입력해주세요.'
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if(this.currentBlog){
        this.content = this.currentBlog.detail
      }
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
    currentBlog(){
      if(this.currentBlog){
        this.content = this.currentBlog.detail
      }
    }
  },
  computed: {
    labelColor() {
      return (label) => {
        const tags = this.$store.state.alarm.alarmTag
        var findTag = tags.find((tag) => { return tag.value == label.tag })
        if(findTag) {
          return findTag.color
        } else{
          return 'dark'
        }
      }
    },
    currentBlog(){
      return this.$store.state.projectBlog.activeBlog
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },  
  methods: {
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
      })
    },
    saveBlog(){
      this.$store.dispatch('projectBlog/updateProjectBlog', {id:this.currentBlog.id, title:this.currentBlog.title, detail:this.content}).then(()=>{
        this.$vs.notify({
          color: 'success',
          title: '저장 완료'
        })
      })
    },
    deleteBlog() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `블로그 삭제`,
        text: '해당 블로그를 삭제하시겠습니까?',
        accept: this.acceptDelete
      })
    },
    acceptDelete() {
        this.$store.dispatch('projectBlog/deleteProjectBlog', this.currentBlog.id).then(()=>{
            this.$emit('deleteBlog', this.currentBlog.pblog_dir_id)
        })
      // this.$store.dispatch('alarm/deleteAlarm', this.openAlarmId)
      // .then(()=>{
      //   this.$emit('closeSidebar')
      //   this.$vs.notify({
      //     color: 'success',
      //     title: '삭제 완료',
      //   })
      // })
    },
    updateBlog() {
      // this.$store.dispatch('project_blog/updateProjectBlog', ).then(()=>{})
    },
  },
  components: {
    quillEditor,
    VuePerfectScrollbar
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}


// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;

        .vs-dialog-text {
            padding: 0;

            .scroll-area {
                max-height: 75vh;

                &:not(.ps) {
                  overflow-y: auto;
                }
            }

            .compose-mail-attachment {
              .con-input-upload {
                margin: 0;
              }
            }
        }
    }

    .con-img-upload {

    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }

    .quill-editor {
        margin-bottom: 1.5rem
    }

    .ql-editor {
        height: 150px;
    }
}

</style>
